import {createContext, PropsWithChildren, useContext, useMemo, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchPreferencesSurveyModal} from "../components/home_match_preferences_survey/HomeMatchPreferencesSurveyModal";

interface IHomeMatchPreferencesSurveyOpenOptions {
    showSentLeadMessage?: boolean;
    source?: PreferencesSurveySource;
}

interface IHomeMatchPreferencesSurveySession {
    showSentLeadMessage: boolean;
    source: PreferencesSurveySource;
}

interface IHomeMatchPreferencesSurveyContext {
    close: () => void;
    isOpen: boolean;
    open: (options?: IHomeMatchPreferencesSurveyOpenOptions) => void;
    setShowSentLeadMessage: (showSentLeadMessage: boolean) => void;
}

const HomeMatchPreferencesSurveyContext = createContext<IHomeMatchPreferencesSurveyContext>({
    close: () => undefined,
    isOpen: false,
    open: () => undefined,
    setShowSentLeadMessage: () => undefined
});

export const HomeMatchPreferencesSurveyProvider = (props: PropsWithChildren) => {
    const {children} = props;
    const [session, setSession] = useState<IHomeMatchPreferencesSurveySession | null>(null);
    const value = useMemo(
        () => ({
            close: () => setSession(null),
            isOpen: session !== null,
            open: (options?: IHomeMatchPreferencesSurveyOpenOptions) =>
                setSession({
                    showSentLeadMessage: Boolean(options?.showSentLeadMessage),
                    source: options?.source ?? PreferencesSurveySource.PREFERENCES
                }),
            setShowSentLeadMessage: (showSentLeadMessage: boolean) =>
                setSession((current) => {
                    if (!current || current.showSentLeadMessage === showSentLeadMessage) return current;

                    return {...current, showSentLeadMessage};
                })
        }),
        [session]
    );

    return (
        <HomeMatchPreferencesSurveyContext.Provider value={value}>
            {children}
            <HomeMatchPreferencesSurveyModal
                isOpen={session !== null}
                onClose={() => setSession(null)}
                preferencesSurveySource={session?.source}
                showSentLeadMessage={session?.showSentLeadMessage}
            />
        </HomeMatchPreferencesSurveyContext.Provider>
    );
};

export const useHomeMatchPreferencesSurvey = () => useContext(HomeMatchPreferencesSurveyContext);
import {createContext, PropsWithChildren, useContext, useMemo, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchPreferencesSurveyModal} from "../components/home_match_preferences_survey/HomeMatchPreferencesSurveyModal";

interface IHomeMatchPreferencesSurveyOpenOptions {
    showSentLeadMessage?: boolean;
    source?: PreferencesSurveySource;
}

interface IHomeMatchPreferencesSurveySession {
    showSentLeadMessage: boolean;
    source: PreferencesSurveySource;
}

interface IHomeMatchPreferencesSurveyContext {
    close: () => void;
    isOpen: boolean;
    open: (options?: IHomeMatchPreferencesSurveyOpenOptions) => void;
    setShowSentLeadMessage: (showSentLeadMessage: boolean) => void;
}

const HomeMatchPreferencesSurveyContext = createContext<IHomeMatchPreferencesSurveyContext>({
    close: () => undefined,
    isOpen: false,
    open: () => undefined,
    setShowSentLeadMessage: () => undefined
});

export const HomeMatchPreferencesSurveyProvider = (props: PropsWithChildren) => {
    const {children} = props;
    const [session, setSession] = useState<IHomeMatchPreferencesSurveySession | null>(null);
    const value = useMemo(
        () => ({
            close: () => setSession(null),
            isOpen: session !== null,
            open: (options?: IHomeMatchPreferencesSurveyOpenOptions) =>
                setSession({
                    showSentLeadMessage: Boolean(options?.showSentLeadMessage),
                    source: options?.source ?? PreferencesSurveySource.PREFERENCES
                }),
            setShowSentLeadMessage: (showSentLeadMessage: boolean) =>
                setSession((current) => {
                    if (!current || current.showSentLeadMessage === showSentLeadMessage) return current;

                    return {...current, showSentLeadMessage};
                })
        }),
        [session]
    );

    return (
        <HomeMatchPreferencesSurveyContext.Provider value={value}>
            {children}
            <HomeMatchPreferencesSurveyModal
                isOpen={session !== null}
                onClose={() => setSession(null)}
                preferencesSurveySource={session?.source}
                showSentLeadMessage={session?.showSentLeadMessage}
            />
        </HomeMatchPreferencesSurveyContext.Provider>
    );
};

export const useHomeMatchPreferencesSurvey = () => useContext(HomeMatchPreferencesSurveyContext);
